
import {
  defineComponent, ref, onMounted,
} from 'vue';
import { useRouter } from 'vue-router';
import { Form, useForm } from 'vee-validate';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store/mainStore';
import AppInput from '@/components/UI/AppInput.vue';
import AppButton from '@/components/UI/AppButton.vue';
import AppSelect from '@/components/UI/AppSelect.vue';
import ValidationService from '@/services/ValidationService';
import { useRegistrationStore } from '../store/registrationStore';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';

// defineRule('required', (value:string) => ValidationService.isNotEmpty(value) || 'This field is required');
// defineRule('alpha', (value) => alpha(value, ['']) || 'Should only contain letters');
// defineRule(
//   'min2',
//   (value: string) => (ValidationService.isLonger(value, 2))
//     || 'Entry is not valid, should be not less then 2 characters',
// );

export default defineComponent({
  components: {
    Form,
    AppInput,
    AppButton,
    AppSelect,
  },
  setup() {
    const mainStore = useMainStore();
    const router = useRouter();
    const registrationStore = useRegistrationStore();
    const firstNameValue = ref<string>(registrationStore.searchUser.firstName);
    const lastNameValue = ref<string>(registrationStore.searchUser.lastName);
    const stateValue = ref<string>(registrationStore.createUser.state);
    const provinceValue = ref<string>(registrationStore.createUser.province);
    const countriesValue = ref<string>(registrationStore.createUser.countryCode);
    const firstNameError = ref('');
    const lastNameError = ref('');
    const countriesError = ref('');
    const statesError = ref('');
    const provincesError = ref('');

    const schema = {
      firstName: 'required',
      lastName: 'required',
      countries: 'required',
      // state: 'required',
      // province: 'required',
    };

    function getStatesData(): void {
      mainStore.fetchStates();
    }

    function getProvincesData(): void {
      mainStore.fetchProvinces();
    }

    function getCountriesData(): void {
      mainStore.fetchCountries();
    }

    function onBeforeSubmit(values) {
      let error = false;

      if (!ValidationService.isNotEmpty(values.firstName)) {
        firstNameError.value = 'This field is required';
        error = true;
      }
      if (!ValidationService.isNotEmpty(values.countries)) {
        countriesError.value = 'This field is required';
        error = true;
      }
      if ((countriesValue.value === 'US') && !ValidationService.isNotEmpty(values.state)) {
        statesError.value = 'This field is required';
        error = true;
      }
      if ((countriesValue.value === 'CA') && !ValidationService.isNotEmpty(values.province)) {
        provincesError.value = 'This field is required';
        error = true;
      }
      if (!ValidationService.isName(values.firstName)) {
        firstNameError.value = 'Should only contain letters';
        error = true;
      }
      if (!ValidationService.isNotEmpty(values.lastName)) {
        lastNameError.value = 'This field is required';
        error = true;
      }
      if (!ValidationService.isName(values.lastName)) {
        lastNameError.value = 'Should only contain letters';
        error = true;
      }
      return !error;
    }

    const { setFieldValue, setValues } = useForm();
    function nextStep(values: any) {
      // eslint-disable-next-line no-param-reassign
      values.firstName = values.firstName.trim();
      // eslint-disable-next-line no-param-reassign
      values.lastName = values.lastName.trim();
      const isFormValid = onBeforeSubmit(values);

      if (!isFormValid) return;
      setFieldValue('firstName', `${values.firstName}`);
      setFieldValue('lastName', `${values.lastName}`);
      registrationStore.searchUser.firstName = values.firstName;
      registrationStore.searchUser.lastName = values.lastName;
      registrationStore.createUser.firstName = values.firstName;
      registrationStore.createUser.lastName = values.lastName;

      registrationStore.createUser.state = stateValue.value || '';
      registrationStore.createUser.province = provinceValue.value || '';
      registrationStore.createUser.countryCode = countriesValue.value || '';
      if (mainStore.user?.hippa) {
        registrationStore.createUser.hippa = mainStore.user.hippa;
      }

      if (registrationStore.createUser.hippa) {
        router.push('step-3');
      } else {
        router.push('step-5');
      }
    }

    onMounted(() => {
      getStatesData();
      getProvincesData();
      getCountriesData();
      MonitoringService.sendPageMountedSpeed();
    });

    return {
      mainStore,
      schema,
      firstNameValue,
      lastNameValue,
      firstNameError,
      lastNameError,
      countriesError,
      stateValue,
      provinceValue,
      countriesValue,
      statesError,
      provincesError,
      nextStep,
      triggerKeyboard() {
        document.querySelectorAll('.el-select[data-is-search="true"]:hover').forEach((v) => {
          const elInput = document.querySelector('.el-select[data-is-search="true"]:hover input[readonly]') as HTMLInputElement;
          if (elInput) {
            elInput.readOnly = false;
            elInput.blur();
            elInput.focus();
          }
        });
      },
    };
  },
});
